(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d-accordion"] && !Shopify.designMode) return;
  try {
    
  class AccordionCustom extends HTMLElement {
    connectedCallback() {
      const details = this.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      this._details = details;
      this._summary = summary;
      this._animation = null;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (this._animation) {
          this._animation.cancel();
          this._animation = null;
        }
        if (details.open) {
          this._close();
        } else {
          this._open();
        }
      });

      details.addEventListener('accordion:close', () => {
        if (details.open && !this._animation) this._close();
      });
    }

    _open() {
      const details = this._details;
      details.open = true;
      const startH = this._summary.offsetHeight;
      const endH = details.scrollHeight;
      details.dataset.animating = '';
      this._animation = details.animate(
        [{ height: startH + 'px' }, { height: endH + 'px' }],
        { duration: 300, easing: 'ease', fill: 'none' }
      );
      this._animation.onfinish = () => {
        delete details.dataset.animating;
        this._animation = null;
      };
    }

    _close() {
      const details = this._details;
      const startH = details.offsetHeight;
      const endH = this._summary.offsetHeight;
      details.dataset.animating = '';
      this._animation = details.animate(
        [{ height: startH + 'px' }, { height: endH + 'px' }],
        { duration: 300, easing: 'ease', fill: 'none' }
      );
      this._animation.onfinish = () => {
        details.open = false;
        delete details.dataset.animating;
        this._animation = null;
      };
    }
  }

  if (!customElements.get('accordion-custom')) {
    customElements.define('accordion-custom', AccordionCustom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class DAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.d-announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.current = 0;
      this.intervalMs = (parseInt(this.dataset.interval) || 4) * 1000;
      this.autoplay = this.dataset.autoplay === 'true';

      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.current - 1));
      if (next) next.addEventListener('click', () => this.go(this.current + 1));

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());

      if (this.autoplay) this.resume();
    }

    go(index) {
      const total = this.slides.length;
      const next = ((index % total) + total) % total;
      if (next === this.current) return;

      const leaving = this.slides[this.current];
      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving');

      this.current = next;
      const entering = this.slides[this.current];
      entering.classList.remove('is-leaving');
      entering.classList.add('is-active');

      let cleaned = false;
      const cleanup = () => {
        if (cleaned) return;
        cleaned = true;
        leaving.classList.remove('is-leaving');
      };
      leaving.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(cleanup, 600);
    }

    pause() {
      clearInterval(this.timer);
    }

    resume() {
      if (!this.autoplay) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => this.go(this.current + 1), this.intervalMs);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('d-announcement-bar-el')) {
    customElements.define('d-announcement-bar-el', DAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-card-carousel"] && !Shopify.designMode) return;
  try {
    
  class DCardCarousel extends HTMLElement {
    connectedCallback() {
      const enableMobile   = this.dataset.sliderMobile  === 'true';
      const enableDesktop  = this.dataset.sliderDesktop === 'true';
      if (!enableMobile && !enableDesktop) return;

      const blazeEl = this.querySelector('.blaze-slider');
      if (!blazeEl) return;

      const slidesMobile   = parseFloat(this.dataset.slidesMobile)   || 1;
      const slidesDesktop  = parseFloat(this.dataset.slidesDesktop)  || 3;
      const colsDesktop    = parseInt(this.dataset.columnsDesktop)   || 3;
      const loop           = this.dataset.loop           === 'true';
      const showArrows     = this.dataset.showArrows     === 'true';
      const showPagination = this.dataset.showPagination === 'true';
      const viewportMq = window.matchMedia('(min-width: 990px)');

      const shouldSlide = () => {
        return viewportMq.matches ? enableDesktop : enableMobile;
      };

      const init = () => {
        const slider = new BlazeSlider(blazeEl, {
          all: {
            slidesToShow: slidesMobile,
            enableAutoplay: false,
            loop: loop,
            draggable: enableMobile,
          },
          '(min-width: 990px)': {
            slidesToShow: enableDesktop ? slidesDesktop : colsDesktop,
            draggable: enableDesktop,
          }
        });

        let currentIndex = 0;
        const dots = [];
        const nav  = this.querySelector('.d-card-carousel__navigation');
        const prev = this.querySelector('.d-card-carousel__arrow--prev');
        const next = this.querySelector('.d-card-carousel__arrow--next');
        const paginationEl = this.querySelector('.d-card-carousel__pagination');

        const syncControls = () => {
          const sliderActive = shouldSlide();
          if (nav) nav.classList.toggle('d-card-carousel__navigation--active', showArrows && sliderActive);
          if (paginationEl) paginationEl.classList.toggle('d-card-carousel__pagination--active', showPagination && sliderActive);
        };

        const updateDots = (index) => {
          const total = this.querySelectorAll('.d-card-carousel__item').length;
          currentIndex = Math.max(0, Math.min(total - 1, index));
          dots.forEach((d, i) => d.classList.toggle('d-card-carousel__dot--active', i === currentIndex));
        };

        if (showArrows) {
          if (prev) prev.addEventListener('click', () => { slider.prev(); updateDots(currentIndex - 1); });
          if (next) next.addEventListener('click', () => { slider.next(); updateDots(currentIndex + 1); });
        }

        if (showPagination) {
          const items = this.querySelectorAll('.d-card-carousel__item');
          if (paginationEl && items.length) {
            items.forEach((_, i) => {
              const dot = document.createElement('button');
              dot.className = 'd-card-carousel__dot' + (i === 0 ? ' d-card-carousel__dot--active' : '');
              dot.setAttribute('aria-label', 'Slide ' + (i + 1));
              dot.addEventListener('click', () => {
                const diff = i - currentIndex;
                if (diff > 0) for (let j = 0; j < diff; j++) slider.next();
                else if (diff < 0) for (let j = 0; j < -diff; j++) slider.prev();
                updateDots(i);
              });
              paginationEl.appendChild(dot);
              dots.push(dot);
            });
          }
        }

        syncControls();
        viewportMq.addEventListener('change', syncControls);
      };

      typeof BlazeSlider !== 'undefined' ? init() : window.addEventListener('load', init, { once: true });
    }
  }
  if (!customElements.get('d-card-carousel-el')) customElements.define('d-card-carousel-el', DCardCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-category-carousel"] && !Shopify.designMode) return;
  try {
    
  class DCategoryCarousel extends HTMLElement {
    connectedCallback() {
      const enableMobile  = this.dataset.sliderMobile  === 'true';
      const enableDesktop = this.dataset.sliderDesktop === 'true';
      const slidesMobile  = parseInt(this.dataset.slidesMobile)  || 3;
      const slidesDesktop = parseInt(this.dataset.slidesDesktop) || 9;

      const blazeEl = this.querySelector('.blaze-slider');
      if (!blazeEl) return;

      const init = () => {
        new BlazeSlider(blazeEl, {
          all: {
            slidesToShow: slidesMobile,
            slidesToScroll: 4,
            enableAutoplay: false,
            loop: false,
            draggable: enableMobile,
          },
          '(min-width: 990px)': {
            slidesToShow: slidesDesktop,
            slidesToScroll: 4,
            draggable: enableDesktop,
          }
        });
      };
      typeof BlazeSlider !== 'undefined' ? init() : window.addEventListener('load', init, { once: true });
    }
  }
  if (!customElements.get('d-category-carousel-el')) customElements.define('d-category-carousel-el', DCategoryCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-collection-subcategories"] && !Shopify.designMode) return;
  try {
    
  class DCollectionSubcategories extends HTMLElement {
    connectedCallback() {
      const enableMobile  = this.dataset.sliderMobile  === 'true';
      const enableDesktop = this.dataset.sliderDesktop === 'true';
      const slidesMobile  = parseInt(this.dataset.slidesMobile)  || 5;
      const slidesDesktop = parseInt(this.dataset.slidesDesktop) || 8;

      const blazeEl = this.querySelector('.blaze-slider');
      if (!blazeEl) return;

      const init = () => {
        new BlazeSlider(blazeEl, {
          all: {
            slidesToShow: 4.5,
            slidesToScroll: 4,
            enableAutoplay: false,
            loop: false,
            draggable: enableMobile,
          },
          '(min-width: 990px)': {
            slidesToShow: slidesDesktop,
            slidesToScroll: slidesDesktop,
            draggable: enableDesktop,
          }
        });
      };
      typeof BlazeSlider !== 'undefined' ? init() : window.addEventListener('load', init, { once: true });
    }
  }
  if (!customElements.get('d-collection-subcategories-el')) customElements.define('d-collection-subcategories-el', DCollectionSubcategories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-footer"] && !Shopify.designMode) return;
  try {
    
  class DFooter extends HTMLElement {
    connectedCallback() {
      this.headers = this.querySelectorAll('.d-footer__column-header');
      this.headers.forEach(header => {
        header.addEventListener('click', this.handleToggle.bind(this));
      });
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    handleToggle(e) {
      const header = e.currentTarget;
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const menuId = header.getAttribute('aria-controls');
      const menu = document.getElementById(menuId);

      if (window.innerWidth < 990) {
        this.headers.forEach(otherHeader => {
          if (otherHeader !== header) {
            otherHeader.setAttribute('aria-expanded', 'false');
            const otherMenuId = otherHeader.getAttribute('aria-controls');
            const otherMenu = document.getElementById(otherMenuId);
            if (otherMenu) otherMenu.style.maxHeight = null;
          }
        });
      }

      header.setAttribute('aria-expanded', !isExpanded);

      if (!isExpanded) {
        menu.style.maxHeight = menu.scrollHeight + 'px';
      } else {
        menu.style.maxHeight = null;
      }
    }

    handleResize() {
      if (window.innerWidth >= 990) {
        this.headers.forEach(header => {
          header.setAttribute('aria-expanded', 'false');
          const menuId = header.getAttribute('aria-controls');
          const menu = document.getElementById(menuId);
          if (menu) menu.style.maxHeight = null;
        });
      }
    }
  }
  if (!customElements.get('d-footer-el')) customElements.define('d-footer-el', DFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-header-main"] && !Shopify.designMode) return;
  try {
    
  class HeaderComponent extends HTMLElement {
    connectedCallback() {
      this._container = this.querySelector('.d-header-main__container');
      const sticky = this.getAttribute('sticky');
      this._lastScrollY = window.scrollY;
      this._ticking = false;
      this._resizeTicking = false;

      this._handleResize = () => {
        if (this._resizeTicking) return;
        this._resizeTicking = true;
        requestAnimationFrame(() => {
          this._syncHeaderHeight();
          this._resizeTicking = false;
        });
      };

      window.addEventListener('resize', this._handleResize, { passive: true });
      window.addEventListener('load', this._handleResize);
      this._syncHeaderHeight();

      if (!sticky) return;

      this._handleScroll = () => {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => {
          this._update();
          this._ticking = false;
        });
      };

      window.addEventListener('scroll', this._handleScroll, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._handleResize);
      window.removeEventListener('load', this._handleResize);
      window.removeEventListener('scroll', this._handleScroll);
    }

    _syncHeaderHeight() {
      if (!this._container) return;

      const containerStyles = window.getComputedStyle(this._container);
      const paddingTop = parseFloat(containerStyles.paddingTop) || 0;
      const paddingBottom = parseFloat(containerStyles.paddingBottom) || 0;

      const visibleChildren = Array.from(this._container.children).filter(
        (child) => child instanceof HTMLElement && child.offsetParent !== null
      );

      const tallestChildHeight = visibleChildren.reduce((maxHeight, child) => {
        const childHeight = child.getBoundingClientRect().height;
        return Math.max(maxHeight, childHeight);
      }, 0);

      const height = Math.ceil(tallestChildHeight + paddingTop + paddingBottom);
      if (height > 0) {
        document.body.style.setProperty('--header-height', `${height}px`);
      }
    }

    _update() {
      const sticky = this.getAttribute('sticky');
      const currentScrollY = window.scrollY;
      const scrollingUp = currentScrollY < this._lastScrollY;

      if (sticky === 'always') {
        if (currentScrollY > 0) {
          this.setAttribute('data-sticky-state', 'active');
        } else {
          this.removeAttribute('data-sticky-state');
        }
      } else if (sticky === 'scroll-up') {
        if (currentScrollY <= 0) {
          this.removeAttribute('data-sticky-state');
        } else if (scrollingUp) {
          this.setAttribute('data-sticky-state', 'active');
        } else if (!scrollingUp) {
          this.removeAttribute('data-sticky-state');
        }
      } else if (sticky === 'responsive-sticky') {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        if (isDesktop) {
          if (currentScrollY > 0) {
            this.setAttribute('data-sticky-state', 'active');
          } else {
            this.removeAttribute('data-sticky-state');
          }
        } else {
          if (currentScrollY <= 0) {
            this.removeAttribute('data-sticky-state');
          } else if (scrollingUp) {
            this.setAttribute('data-sticky-state', 'active');
          } else {
            this.removeAttribute('data-sticky-state');
          }
        }
      }

      this._lastScrollY = currentScrollY;
    }
  }

  customElements.define('header-component', HeaderComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-icons-bar"] && !Shopify.designMode) return;
  try {
    
  class DIconsBar extends HTMLElement {
    connectedCallback() {
      this.bindCopyButtons();
    }

    bindCopyButtons() {
      const buttons = this.querySelectorAll('[data-copy-text]');
      buttons.forEach((button) => {
        if (button.dataset.copyBound === 'true') return;
        button.dataset.copyBound = 'true';
        button.addEventListener('click', () => {
          const text = button.getAttribute('data-copy-text') || '';
          if (!text) return;

          button.style.minWidth = button.offsetWidth + 'px';

          const copiedLabel = button.getAttribute('data-copied-label');
          const originalLabel = button.dataset.originalLabel || button.textContent;
          if (!button.dataset.originalLabel) {
            button.dataset.originalLabel = originalLabel;
          }

          const fallbackCopy = () => {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            textarea.remove();
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(fallbackCopy);
          } else {
            fallbackCopy();
          }

          if (copiedLabel) {
            button.textContent = copiedLabel;
          }
          button.classList.add('is-copied');

          window.setTimeout(() => {
            button.textContent = button.dataset.originalLabel || originalLabel;
            button.classList.remove('is-copied');
          }, 1600);
        });
      });
    }
  }
  if (!customElements.get('d-icons-bar-el')) customElements.define('d-icons-bar-el', DIconsBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
